import { Loader2 } from "lucide-react";

export function PageSpinner() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center" role="status" aria-live="polite">
      <Loader2 className="size-6 animate-spin text-primary" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
